'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var searchComponent = exports.searchComponent = {
    template: require('./search.html'),
    controllerAs: 'vm',
    bindings: {
        parentState: '<'
    },
    controller: ["$stateParams", "$scope", "productOverviewService", "Enums", "common", "gettextCatalog", "Analytics", function controller($stateParams, $scope, productOverviewService, Enums, common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.searchValue = $stateParams.searchValue;
        vm.productOverviewModel = null;
        vm.$onInit = init;

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('Search') + ' ' + vm.searchValue);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/search/' + vm.searchValue, 'Search ' + vm.searchValue);

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.search.id);
            productOverviewService.getProductsBySearchValue(true, vm.productOverviewModel, vm.searchValue).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsBySearchValue(false, vm.productOverviewModel, vm.searchValue).then(function (model) {
                    vm.productOverviewModel = model;
                });
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/search/search.js
// module id = 1007
// module chunks = 0